import { SystemRole } from '../types/index.js';
const ROLE_HIERARCHY = {
    [SystemRole.ADMIN]: 100,
    [SystemRole.PLANNER]: 50,
    [SystemRole.CLIENT]: 20,
    [SystemRole.VENDOR]: 10,
};
export function hasMinimumRole(userRole, requiredRole) {
    return ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[requiredRole];
}
export function isAdmin(role) {
    return role === SystemRole.ADMIN;
}
export function isPlannerOrAbove(role) {
    return hasMinimumRole(role, SystemRole.PLANNER);
}
//# sourceMappingURL=permissions.js.map